import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import ImageView from 'lib/images/image-view';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';
import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import Avatar from 'four-nets/avatar/avatar';
import IconCamera from 'four-nets/icons/svg/icon_photo.svg';
import IconHeart from 'four-nets/icons/svg/icon_heart.svg';
import IconHeartFull from 'four-nets/icons/svg/icon_heart-full.svg';
import IconActivity from 'four-nets/icons/svg/icon_activity2.svg';
import { displayedName } from 'four-nets/user/utils';

import { CollectionNodeFragment } from './collection-node.graphql';
import defaultStyles from './collection-node.scss';

export interface Props extends CollectionNodeFragment {
    styles: typeof defaultStyles;
}

class CollectionNode extends React.PureComponent<Props> {
    render() {
        const {
            styles,
            href,
            isNew,
            imagesCount,
            likesCount,
            isLikedByViewer,
            title,
            images,
            photoblog,
            lastModified,
        } = this.props;
        const user = photoblog && photoblog.user!;

        return (
            <React.Fragment>
                <div className={styles.header}>
                    <Avatar style={{ avatar: styles.avatar }} user={user} />
                    <div className={styles.headerInfo}>
                        <Link className={styles.usernameLink} to={`/blog/${user.username}/`}>
                            <p className={styles.username}>{displayedName(user)}</p>
                        </Link>
                        <div className={styles.time}>
                            <SVGIcon className={styles.iconActivity} src={IconActivity} />
                            <p className={styles.timeText}>
                                <FormattedDateAgoView value={new Date(lastModified || '')} />
                            </p>
                        </div>
                    </div>
                </div>
                <Link to={href!}>
                    <div className={styles.images}>
                        {images && images.edges
                            ? images.edges.map(imgEdge =>
                                  imgEdge &&
                                  imgEdge.node &&
                                  imgEdge.node.image &&
                                  imgEdge.node.image.photoFile &&
                                  imgEdge.node.image.photoFile.srcset ? (
                                      <div key={imgEdge.node.id}>
                                          <ImageView
                                              linkify={false}
                                              aspectFill={true}
                                              srcSet={imgEdge.node.image.photoFile.srcset}
                                              src={imgEdge.node.image.photoFile.src}
                                              sizes={{ xs: 200 }}
                                          />
                                      </div>
                                  ) : null
                              )
                            : null}
                    </div>
                </Link>
                <div className={styles.footer}>
                    <Link className={styles.titleLink} to={href!}>
                        <p className={styles.title}>{title}</p>
                    </Link>
                    <div className={styles.bottom}>
                        <div className={styles.stats}>
                            <SVGIcon className={styles.iconCamera} src={IconCamera} />
                            <span className={styles.statText}>{imagesCount}</span>
                            {likesCount && likesCount > 0 ? (
                                <React.Fragment>
                                    <SVGIcon
                                        className={styles.iconHeart}
                                        src={isLikedByViewer ? IconHeartFull : IconHeart}
                                    />
                                    <span className={styles.statText}>{likesCount}</span>
                                </React.Fragment>
                            ) : null}
                        </div>
                        {isNew ? (
                            <p className={styles.new}>
                                <FormattedMessage id='NEW' />
                            </p>
                        ) : null}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(CollectionNode);
